import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import TopCompanies from "app/pages/sales-intelligence/modules/top-companies/containers/TopCompanies";
import { ContactsFlowProvider } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext";

import { useHomeContactsFlowStrategy } from "../../hooks/useHomeContactsFlowStrategy";

const TopCompaniesContainer = () => {
    const contactsFlowStrategy = useHomeContactsFlowStrategy();

    return (
        <Stack gap="16px">
            <Text
                fontVariant="h5"
                data-automation="title"
            >
                {translate("si.top-companies.title")}
            </Text>

            <ContactsFlowProvider value={contactsFlowStrategy}>
                <TopCompanies />
            </ContactsFlowProvider>
        </Stack>
    );
};

export default TopCompaniesContainer;
